import Logo from 'assets/general/Logo_BMI_Geo_Risk_Signals_White.svg';
import { ReactNode } from 'react';

const NoPermissions = ({ children }: { children: ReactNode }) => {
    return (
        <div className="preload-error">
            <div className="preload-error-logo">
                <img src={Logo} alt="" />
            </div>
            {children}
        </div>
    );
};

export default NoPermissions;
